import { Box, Card, CardContent, Typography, useTheme } from '@mui/material';
import type { FC } from 'react';
import { useState } from 'react';
import { ForgotPassword } from './forgot-password.js';
import { SignIn } from './sign-in.js';

const Footer: FC<{ color: string }> = ({ color }) => (
  <Typography sx={{ color, fontSize: 'small', m: 1 }}>
    Copyright &copy;
  </Typography>
);

export const NotAuthenticatedPage: FC = () => {
  const theme = useTheme();
  const [forgot, setForgot] = useState(false);

  return (
    <Box
      sx={{
        bottom: 0,
        left: 0,
        overflow: 'auto',
        position: 'absolute',
        right: 0,
        top: 0,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          alignSelf: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          maxWidth: 360,
          minHeight: '100%',
          mx: 'auto',
          p: 3,
        }}
      >
        <Card elevation={6}>
          <CardContent
            sx={{ backgroundColor: theme.palette.secondary.main, py: 2 }}
          >
            <Typography sx={{ textAlign: 'center' }} variant="h5">
              Patrol Roster
            </Typography>
          </CardContent>
          <CardContent>
            {!forgot ? (
              <SignIn forgotPassword={() => setForgot(true)} />
            ) : (
              <ForgotPassword back={() => setForgot(false)} />
            )}
          </CardContent>
        </Card>
        <Footer color={theme.palette.text.disabled} />
      </Box>
    </Box>
  );
};
